import {observer} from "mobx-react";
import React from "react";
import SelectRangeDate from "@dropDesk/presentation/components/dates/select_range_date";
import {PeriodEnum} from "@dropDesk/utils/helpers/common";
import {Tooltip} from "antd";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import toastMessage from "@dropDesk/utils/toast_message/toast_message";

const TICKET_LIST_PRESET_BUTTONS: PeriodEnum[] = [
    PeriodEnum.last3Months,
    PeriodEnum.last6Months,
    PeriodEnum.last12Months,
    PeriodEnum.currentMonth,
    PeriodEnum.lastMonth,
    PeriodEnum.currentWeek,
];

const TICKET_LIST_PERIOD_LABELS: Partial<Record<PeriodEnum, string>> = {
    [PeriodEnum.currentWeek]: 'Semana atual',
    [PeriodEnum.currentMonth]: 'Mês atual',
    [PeriodEnum.lastMonth]: 'Mês passado',
    [PeriodEnum.last3Months]: 'Últimos 3 meses',
    [PeriodEnum.last6Months]: 'Últimos 6 meses',
    [PeriodEnum.last12Months]: 'Últimos 12 meses',
};

const getTicketListPeriodLabel = (labelPeriod: PeriodEnum | null): string => {
    if (labelPeriod === PeriodEnum.custom) {
        return 'Personalizado';
    }
    if (labelPeriod) {
        return TICKET_LIST_PERIOD_LABELS[labelPeriod] ?? 'Personalizado';
    }
    return 'Últimos 3 meses';
};

const InputPeriodSearch = observer(
    ({
         period,
         labelPeriod,
         setFilterPeriod,
         loading,
         hideLabel,
         size,
         variant = 'default',
     }: {
        period: Array<Date> | null
        labelPeriod: PeriodEnum | null
        setFilterPeriod: (period: Array<Date> | null, label: PeriodEnum | null, withList?: boolean) => void
        loading: boolean,
        hideLabel?: boolean,
        size?: number
        variant?: 'default' | 'ticketList'
    }) => {
        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;
        const isTicketList = variant === 'ticketList';

        return (
            <>
                <Tooltip title={hideLabel ? 'Filtrar por período' : undefined}>
                    <div style={{display: "flex", flex: 1, minWidth: isTicketList ? 220 : undefined}}>
                        <SelectRangeDate
                            disabled={isTicketList ? false : loading}
                            size={size ?? 40}
                            label={isTicketList ? getTicketListPeriodLabel(labelPeriod) : (hideLabel ? undefined : !labelPeriod ? 'Período' : undefined)}
                            labelVariant={isTicketList ? 'outlined' : 'default'}
                            allowClear={!isTicketList}
                            value={period}
                            onChange={(arrayDate, label) => {
                                setFilterPeriod(arrayDate, label);
                            }}
                            labelPeriodCustom={isTicketList || hideLabel ? undefined : labelPeriod ?? null}
                            borderColor={period ? colors.accent : colors.border}
                            presetButtons={isTicketList ? TICKET_LIST_PRESET_BUTTONS : undefined}
                            maxRangeDays={isTicketList ? 366 : undefined}
                            onRangeRejected={() => {
                                toastMessage.error('O período selecionado não pode ultrapassar 1 ano.');
                            }}
                        />
                    </div>
                </Tooltip>
            </>
        )
    })
export default InputPeriodSearch;
